import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
import openUserStories from '../openUserStories';

/**
 * "<user> replied to your story", with the start of the reply underneath.
 *
 * Opens the very story that was replied to — not the author's first one — so
 * the reply can be read where it belongs. A story that has since expired is
 * reported as such by openUserStories.
 */
export default class StoryRepliedNotification extends Notification {
  icon() {
    return 'fas fa-reply';
  }

  href() {
    // A path core can inspect for its external-link check; markAsRead below
    // opens the viewer instead of navigating. See StoryLikedNotification.
    return app.route('index');
  }

  markAsRead(e) {
    if (e) e.preventDefault();

    super.markAsRead();

    const subject = this.attrs.notification.subject();

    // It is the actor's own story that was replied to.
    if (app.session.user) openUserStories(app.session.user, subject && subject.id());
  }

  content() {
    return app.translator.trans('happydigital-stories.forum.notifications.story_replied', {
      user: this.attrs.notification.fromUser(),
    });
  }

  excerpt() {
    const data = this.attrs.notification.content() || {};

    return data.excerpt || null;
  }
}
